import React, { Fragment } from 'react';

import CallToAction from './CallToAction';

function Welcome() {
  return (
    <Fragment>
      <header>
        <h1>Tervetuloa!</h1>
      </header>
      <main>
        <section>
          <p>
            Sensotrend Connect auttaa sinua siirtämään tiedot verensokerimittareista,
            glukoosisensoreista ja insuliinipumpuista Kanta-palveluiden Omatietovarantoon.
          </p>
          <p>
            Kun tiedot ovat Omatietovarannossa, voit käyttää haluamiasi sovelluksia tietojen
            visualisointiin ja analysointiin, ja voit myös jakaa tietosi lääkärisi ja hoitajasi
            kanssa.
          </p>
          <CallToAction action="/signin">
            Aloitetaan!
          </CallToAction>
          <a
            className="secondary button"
            target="instructions"
            rel="noopener noreferrer"
            href="/connect/ohjeet/sensotrend-connect"
          >
            Yksityiskohtaiset ohjeet
          </a>
        </section>
      </main>
    </Fragment>
  );
}

export default Welcome;
